module.exports = __webpack_public_path__ + "img/pop_zi@2x.c1056b28.png";